import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@material-ui/styles";
import Menu from "@mui/material/Menu";
import AvatarBasic from "../../../../../common/components/avatar/AvatarBasic";
import ListItemBasic from "../../../../../common/components/listitem/ListItemBasic";
import Act from "../../../../../store/actions";
import { StoreContext } from "../../../../../store/StoreProvider";
// config, utils

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  "&.MuiCheckbox-root": {
    paddingTop: 0,
    paddingBottom: 0,
    "&.Mui-checked": {
      color: "#3bbff0",
    },
    "& .Mui-checked": {
      color: "#3bbff0",
    },
  },
}));

// 規格：
// darkMode: true/false
// checkbox:有/無
// avatar:有/無
// avatar:image/text
// primary text: 有/無
// secondary text: 有/無

const CommonListItem = ({
  context,
  withCheckbox,
  withAvatar,
  checked,
  onCheckboxChange,
  onListItemClick,
  darkMode,
  secondaryAction,
  avatarSize,
  listItemStyle,
}) => {
  // props
  const { imgSrc, textPrimary, textSecondary } = context;
  const [state, dispatch] = useContext(StoreContext);

  const getAvatarSx = () => {
    if (avatarSize === "normal") {
      return {
        sx: {
          width: "32px",
          height: "32px",
          fontSize: "14px",
          marginRight: "8px",
        },
      };
    }
    return {
      sx: {
        width: "24px",
        height: "24px",
        fontSize: "12px",
        marginRight: "8px",
      },
    };
  };
  const getAvatar = () => {
    if (imgSrc) {
      return (
        <AvatarBasic
          avatarProps={{
            letter: textPrimary,
            src: imgSrc,
            ...getAvatarSx(),
          }}
        />
      );
    }
    if (textPrimary) {
      return (
        <AvatarBasic
          avatarProps={{
            letter: textPrimary,
            ...getAvatarSx(),
          }}
        />
      );
    }
    return null;
  };

  const getCheckboxSx = () => {
    if (darkMode) {
      return {
        sx: {
          color: "#505050",
        },
      };
    }
    return {};
  };
  const getCheckbox = () => {
    if (withCheckbox) {
      return (
        <StyledCheckbox
          edge="start"
          checked={checked}
          tabIndex={-1}
          disableRipple
          onChange={(e) => {
            if (onCheckboxChange) onCheckboxChange(e, context);
          }}
          {...getCheckboxSx()}
        />
      );
    }
    return null;
  };

  const getListIcon = () => {
    if (withCheckbox || withAvatar) {
      return (
        <Box display="flex" alignItems="center">
          {withCheckbox && getCheckbox()}
          {withAvatar && getAvatar()}
        </Box>
      );
    }
    return null;
  };

  const getListItemBasicProps = () => {
    const customProps = {};
    if (listItemStyle) {
      customProps.sx = listItemStyle;
    }
    if (getListIcon()) {
      customProps.listIcon = getListIcon();
    }
    if (textPrimary) {
      customProps.textPrimary = textPrimary;
    }
    if (textSecondary) {
      customProps.textSecondary = textSecondary;
    }
    return customProps;
  };

  const getListItemTextProps = () => {
    if (darkMode) {
      return {
        sx: {
          color: "#fff",
          "& span": {
            color: "#fff",
            fontSize: "14px",
          },
          "& p": {
            color: "#c9c9c9",
            fontSize: "12px",
          },
        },
      };
    }
    return {
      sx: {
        "& span": {
          fontSize: "14px",
        },
        "& p": {
          fontSize: "12px",
        },
      },
    };
  };

  return (
    context && (
      <ListItemBasic
        {...getListItemBasicProps()}
        listItemProps={{
          secondaryAction,
        }}
        listItemButtonProps={{
          onClick: (e) => {
            if (onListItemClick) onListItemClick(e);
            if (checked && context.textPrimary === "啟用事件分類功能")
              dispatch({ type: Act.SNA_SET_EVN_CTG_DIALOG, payload: true });
          },
        }}
        listItemTextProps={{
          ...getListItemTextProps(),
        }}
      />
    )
  );
};

CommonListItem.propTypes = {
  context: PropTypes.objectOf(PropTypes.any),
  withCheckbox: PropTypes.bool,
  withAvatar: PropTypes.bool,
  checked: PropTypes.bool,
  onCheckboxChange: PropTypes.func,
  onListItemClick: PropTypes.func,
  darkMode: PropTypes.bool,
  secondaryAction: PropTypes.node,
  avatarSize: PropTypes.oneOf(["normal", "small"]),
  listItemStyle: PropTypes.objectOf(PropTypes.any),
};

CommonListItem.defaultProps = {
  context: null,
  withCheckbox: false,
  withAvatar: true,
  checked: false,
  onCheckboxChange: () => null,
  onListItemClick: () => null,
  darkMode: false,
  secondaryAction: null,
  avatarSize: "normal",
  listItemStyle: undefined,
};

export default CommonListItem;
